import { apicall } from "../../services/api";
import {
	USER_LOADED,
	AUTH_ERROR,
	LOGIN_SUCCESS,
	LOGOUT,
} from "./actionTypes";
import {setAuthToken} from "../../services/setAuthToken";
import { setAlert } from "./alert.actions";
import { Toastify } from "../../services/toastify/toastifyContainer";
import { getAllUsers } from "./user.actions";
import { toast } from "react-toastify";


export const loadUser = () => async (dispatch) => {
	if (localStorage.token) {
		try {
			await setAuthToken(localStorage.token);
			const res = await apicall("api/v1/admins/getuserDetail", "get");
			dispatch({
				type: USER_LOADED,
				payload: res.data.data,
			});
			// debugger
		} catch (err) {
			if(err.response.status  === 401 && err.response.data.msg === 'Token has expired'){
				localStorage.clear();
				setAuthToken("");
			}
			dispatch({
				type: AUTH_ERROR,
				payload: { msg: err.response.statusText, status: err.response.status },
			});
			dispatch(setAlert(err.response.statusText, "error"));
		}
	} else {
		dispatch({
			type: AUTH_ERROR,
			payload: { msg: "Authentication error", status: 500 },
		});
		dispatch(setAlert("Authentication error", "error"));
	}
};

//Login User
export const login = (email, password) => async (dispatch) => {
	const body = { email, password };
	try {
		const res = await apicall(`api/v1/admins/login`, "post", body);
		await dispatch({
			type: LOGIN_SUCCESS,
			payload: res.data.data,
		});
		await dispatch(setAlert(res.data.message, "success"));
		toast.success(res.data.message);
		await dispatch(loadUser());
		if(localStorage.token){
			dispatch(getAllUsers())
		}
		return res.data
	} catch (err) {
		console.log(err);
		// Toastify({ data: "error", msg: err.response.data.msg })
		toast.error(err.response.data.msg);

	}
};

//Logout / Clear profile
export const logout = () => (dispatch) => {
	dispatch({ type: LOGOUT });
};
